export default {
  root: ({ props }) => ({
    class: [
      // Spacing and Shape
      'my-2 mx-0',
      'rounded-10',

      // Colors
      {
        'bg-primary dark:bg-blue-500/20': props.severity == 'info',
        'bg-green dark:bg-green-500/20':
          props.severity == 'success' || props.severity == 'secondary',
        'bg-orange-100/70 dark:bg-orange-500/20': props.severity == 'warn',
        'bg-red-100/70 dark:bg-red-500/20': props.severity == 'error'
      },
      {
        'border-blue-500 dark:border-blue-400': props.severity == 'info',
        'border-green-500 dark:border-green-400':
          props.severity == 'success' || props.severity == 'secondary',
        'border-orange-500 dark:border-orange-400': props.severity == 'warn',
        'border-red-500 dark:border-red-400': props.severity == 'error'
      },
      {
        'text-white dark:text-blue-300': props.severity == 'info',
        'text-white dark:text-green-300':
          props.severity == 'success' || props.severity == 'secondary',
        'text-orange-700 dark:text-orange-300': props.severity == 'warn',
        'text-red-700 dark:text-red-300': props.severity == 'error'
      }
    ]
  }),
  wrapper: {
    class: [
      // Flexbox
      'flex items-center justify-center',

      // Spacing
      'py-2 px-8'
    ]
  },
  icon: ({ props }) => ({
    class: [
      // Sizing and Spacing
      'w-5 h-5',
      'text-xl leading-normal mr-2 shrink-0',
      {
        hidden: props.severity == 'error'
      }
    ]
  }),
  text: ({ props }) => ({
    class: [
      // Font and Text
      'text-lg leading-normal',
      'font-bold',
      {
        'text-sm': props.severity == 'error'
      }
    ]
  }),
  button: {
    class: [
      // Flexbox
      'flex items-center justify-center',

      // Size
      'w-8 h-8',

      // Spacing and Misc
      'ml-auto  relative',

      // Shape
      'rounded-full',

      // Colors
      'bg-transparent',

      // Transitions
      'transition duration-200 ease-in-out',

      // States
      'hover:bg-surface-0/50 dark:hover:bg-surface-0/10',

      // Misc
      'overflow-hidden'
    ]
  },
  transition: {
    enterFromClass: 'opacity-0',
    enterActiveClass: 'transition-opacity duration-300',
    leaveFromClass: 'max-h-40',
    leaveActiveClass: 'overflow-hidden transition-all duration-300 ease-in',
    leaveToClass: 'max-h-0 opacity-0 !m-0'
  }
}
